const META = {
  draft: { label: "Borrador", color: "#7C7560", bg: "#EEE4CE" },
  pending_approval: { label: "En revisión", color: "#8A5A00", bg: "#FCEFC7" },
  approved: { label: "Aprobada", color: "#0F5132", bg: "#D1F2E0" },
  rejected: { label: "Rechazada", color: "#7F1D1D", bg: "#FCD3D3" },
  published: { label: "Publicada", color: "#1B225E", bg: "#DCE0FF" },
};

export default function EvalStatusBadge({ status, size = "sm" }) {
  const m = META[status] || META.draft;
  const pad = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`eval-status-${status}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider border ${pad}`}
      style={{ background: m.bg, color: m.color, borderColor: m.color }}
    >
      {m.label}
    </span>
  );
}
